'use strict';

exports.__esModule = true;
exports.updateValueByIdentifier = undefined;

var _TagSchemas = require('../../types/TagSchemas');

var _isEmpty = require('../../utils/is-empty');

var _buildTagByValue = require('../utils/build-tag-by-value');

var _updateBySchema = require('./update-by-schema');

var updateValueByIdentifier = exports.updateValueByIdentifier = function updateValueByIdentifier() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var identifier = arguments[1];
  var value = arguments[2];
  var meta = arguments[3];

  var tag = (0, _buildTagByValue.buildTagByValueAndIdentifier)(value, identifier);
  if ((0, _isEmpty.isEmpty)(tag)) {
    return tags;
  }

  if (meta) {
    tag.meta = meta;
  }

  var tagSchema = _TagSchemas.TAG_SCHEMAS[identifier];

  return (0, _updateBySchema.updateValueBySchema)(tags, tagSchema, value, meta);
};